import React from 'react';
import { FormattedMessage } from 'react-intl';
import UserAvatar from '../../../../chat/components/UserAvatar';
import { backgroundImage as backgroundUserImage } from '../../../../icons/User';
import { SIZE_ALIAS } from '../../../../core/hocs/withSize';
import useChannel from '../../../../chat/hooks/useChannel';
import useChannelMembers from '../../../../chat/hooks/useChannelMembers';
// TODO: no import from social
import LoadMore from '../../../../social/components/LoadMore';
import AddNewMember from './AddNewMember';
import { ChatMembersContainer, MembersReturn, MembersArrowLeft, MembersReturnTitle, MemberItem, MemberItemInfo, } from './styles';
const DEFAULT_DISPLAY_NAME = 'Anonymous';
const ChatDetailsMembers = ({ channelId, hideMembers, onEditChatMemberClick, onMemberSelect }) => {
    const channel = useChannel(channelId);
    const [members, hasMore, loadMore] = useChannelMembers(channelId, channel.memberCount);
    const handleReturnClick = (e) => {
        e.stopPropagation();
        hideMembers();
    };
    const getName = (member) => {
        var _a;
        const { displayName, metadata } = (_a = member === null || member === void 0 ? void 0 : member.user) !== null && _a !== void 0 ? _a : {};
        if (displayName)
            return displayName;
        const { firstname = '', lastname = '' } = metadata !== null && metadata !== void 0 ? metadata : {};
        const name = `${firstname} ${lastname}`;
        return name.trim();
    };
    return (React.createElement(ChatMembersContainer, null,
        React.createElement(MembersReturn, { onClick: handleReturnClick },
            React.createElement(MembersArrowLeft, null),
            React.createElement(MembersReturnTitle, null,
                React.createElement(FormattedMessage, { id: "chat.members.return" }))),
        React.createElement(LoadMore, { hasMore: hasMore, loadMore: loadMore },
            members.map((member) => {
                var _a;
                return (React.createElement(MemberItem, { key: member.userId, onClick: () => onMemberSelect(member) },
                    React.createElement(UserAvatar, Object.assign({ size: SIZE_ALIAS.SMALL, defaultImage: backgroundUserImage }, (_a = member === null || member === void 0 ? void 0 : member.user) === null || _a === void 0 ? void 0 : _a.model)),
                    React.createElement(MemberItemInfo, null, getName(member) || DEFAULT_DISPLAY_NAME)));
            }),
            onEditChatMemberClick && (React.createElement(AddNewMember, { onClick: () => onEditChatMemberClick({ channelId, members }) })))));
};
export default ChatDetailsMembers;
//# sourceMappingURL=index.js.map